import { FilterOperation } from '../types';

export const operationsMappingWithLabel = {
  [FilterOperation.IS]: 'Is',
  [FilterOperation.IS_NOT]: 'Is not',
  [FilterOperation.IS_EMPTY]: 'Is empty',
  [FilterOperation.IS_NOT_EMPTY]: 'Is not empty',
  [FilterOperation.CONTAINS]: 'Contains',
  [FilterOperation.DOES_NOT_CONTAIN]: 'Does not contain',
  [FilterOperation.EQUAL]: 'Equal',
  [FilterOperation.NOT_EQUAL]: 'Is not equal',
  [FilterOperation.GREATER_THAN]: 'Is greater than',
  [FilterOperation.GREATER_THAN_OR_EQUAL]: 'Is greater than or equal',
  [FilterOperation.LESS_THAN_OR_EQUAL]: 'Is less than or equal',
  [FilterOperation.LESS_THAN]: 'Is less than',
  [FilterOperation.BETWEEN]: 'Is between',
  [FilterOperation.IS_WITHIN]: 'Is within',
  [FilterOperation.IS_BEFORE]: 'Is before',
  [FilterOperation.IS_AFTER]: 'Is after',
  [FilterOperation.IS_ON_OR_BEFORE]: 'Is on or before',
  [FilterOperation.IS_ON_OR_AFTER]: 'Is on or after',
  [FilterOperation.START_WITH]: 'Starts with',
  [FilterOperation.IN]: 'In',
  [FilterOperation.NOT_IN]: 'Not in',
};
